// extracted by mini-css-extract-plugin
export default {"logobox":"Header_logobox__t0v8Q","logoutbox":"Header_logoutbox__3sll3","logoimg":"Header_logoimg__4H+nA"};